<div class="tertiary-nav">
  <ul class="tertiary-nav-list">
    <li *ngFor="let navItem of navItems; let i = index" class="tertiary-nav-item" routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      [ngClass]="{'active': activeItemId === navItem.id, 'expandable-item': navItem?.items?.length > 0}"
      (click)="onNavbarItemClick(navItem)">

      <div *ngIf="!navItem?.items?.length" class="nav-content">
        <div class="nav-label" [routerLink]="navItem.link">
          <i *ngIf="navItem.iconType !== 'image'" [hidden]="!navItem.icon" [ngClass]="{'default-icon': true}"
            [class]="navItem.icon" style="width: 25px;"></i>
          <span *ngIf="navItem.iconType === 'image' && activeItemId === navItem.id; else imageInactive"
            style="margin-right: 9px;">
            <img [ngClass]="{'image-active': true}" [class]="navItem.id"
              [src]="'../../../../../' + navItem.imgActiveSrc" [ngClass]="{'default-icon': true}">
          </span>
          <ng-template #imageInactive>
            <span *ngIf="navItem.iconType === 'image'" style="margin-right: 9px;">
              <img [ngClass]="{'image-inactive': true}" [class]="navItem.id" [src]="'../../../../../' + navItem.imgSrc"
                [ngClass]="{'default-icon': true}">
            </span>
          </ng-template>
          <i class="fal fa-chevron-right expand-icon"></i>
          <span class="item-label">
            {{navItem.label}}
          </span>
        </div>
      </div>

      <div *ngIf="navItem?.items?.length" class="nav-content">
        <div class="nav-label" [routerLink]="navItem.link">
          <i [hidden]="!navItem.icon" [ngClass]="{'default-icon': true}" [class]="navItem.icon"></i>
          <i class="fal fa-chevron-right expand-icon"></i>
          <img *ngIf="navItem.iconType === 'image' && activeItemId === navItem.id; else iconInactive"
            [ngClass]="{'image-active': true}" [class]="navItem.id" [src]="'../../../../../' + navItem.imgActiveSrc"
            [ngClass]="{'default-icon': true}">
          <ng-template #iconInactive>
            <img *ngIf="navItem.iconType === 'image'"
              [ngClass]="{'image-inactive': true}" [class]="navItem.id" [src]="'../../../../../' + navItem.imgSrc"
              [ngClass]="{'default-icon': true}">
          </ng-template>
          <span class="item-label ml-2">
            {{navItem.label}}
          </span>
        </div>

        <ul class="tertiary-sub-list">
          <li class="tertiary-sub-item" *ngFor="let navSubItem of navItem?.items"
            [ngClass]="{'active': navSubItem.id === activeSubItemId}">
            <div class="sub-nav-label flex-start-center">
              <div class="sub-item-label ml-2" [routerLink]="navSubItem.link"
                (click)="onNavbarSubItemClick(navItem, navSubItem, $event)">
                {{navSubItem.label}}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
